import React from 'react';
import { Button } from '@indeed/ifl-components';
import Header from 'Components/Header';
import LinkButton from 'Components/LinkButton/LinkButton';
import PreloadImages from 'Components/PreloadImages';
import ConbiniColor from 'Img/conbini-color.svg';
import GuideImage1 from 'Img/desktop-start1.svg';
import GuideImage2 from 'Img/desktop-start2.svg';
import GuideImage3 from 'Img/desktop-start3.svg';
import FulltimeIcon from 'Img/fulltime-icon.svg';
import HomeIcon from 'Img/home-icon.svg';
import ParttimeIcon from 'Img/parttime-icon.svg';
import ResumeIcon from 'Img/resume-icon.svg';
import InitialPageUtil from 'Utils/InitialPageUtil';
import JsvMetricsLogger from 'Utils/JsvMetricsLogger';
import { IS_LOGGED_IN } from 'Utils/PassportUtil';
import { LegalDisclaimer } from 'Views/HomePage/LegalDisclaimer';
import PassportLinks from './_PassportLinks';
import './_DesktopStartPage.scss';
const HOME_PAGE = '/home';
const DesktopStartPage = () => {
    const handleClickStart = () => InitialPageUtil.skipStartPageNextTime('tos_button');
    JsvMetricsLogger.log('page_view', 'show_tos_screen', 'tos_screen');
    const isPassportLinksShown = !IS_LOGGED_IN;
    return (React.createElement("div", { className: "DesktopStartPage" },
        React.createElement(PreloadImages, { images: [FulltimeIcon, ParttimeIcon, HomeIcon, ResumeIcon, ConbiniColor] }),
        React.createElement(Header, { type: "nav" }),
        React.createElement("div", { className: "DesktopStartPage-title" }, "\u5C65\u6B74\u66F8\u4F5C\u6210\u3078\u3088\u3046\u3053\u305D!"),
        React.createElement("div", { className: "DesktopStartPage-subtitle" }, "\u4ECA\u307E\u3067\u624B\u66F8\u304D\u3067\u4F5C\u6210\u3057\u3066\u3044\u305F\u5C65\u6B74\u66F8\u3092\u3001PC\u3067\u30AB\u30F3\u30BF\u30F3\u4F5C\u6210\uFF01"),
        React.createElement("div", { className: "DesktopStartPage-guides" },
            React.createElement("div", { className: "DesktopStartPage-guide" },
                React.createElement("img", { src: GuideImage1, alt: "" }),
                React.createElement("div", { className: "DesktopStartPage-guideText" },
                    "\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u306F\u30A2\u30EB\u30D0\u30A4\u30C8\u30FB",
                    React.createElement("br", null),
                    "\u30D1\u30FC\u30C8\u7528\u3068\u8EE2\u8077\u7528\u3092\u3054\u7528\u610F")),
            React.createElement("div", { className: "DesktopStartPage-guide" },
                React.createElement("img", { src: GuideImage2, alt: "" }),
                React.createElement("div", { className: "DesktopStartPage-guideText" },
                    "\u30B9\u30AD\u30EB\u3084\u8A00\u8A9E\u30FB\u8A9E\u5B66\u306F",
                    React.createElement("br", null),
                    "\u8C4A\u5BCC\u306A\u9078\u629E\u80A2\u3067\u30E9\u30AF\u30E9\u30AF\u5165\u529B")),
            React.createElement("div", { className: "DesktopStartPage-guide" },
                React.createElement("img", { src: GuideImage3, alt: "" }),
                React.createElement("div", { className: "DesktopStartPage-guideText" },
                    "\u30B3\u30F3\u30D3\u30CB\u3067\u76F4\u63A5\u5370\u5237",
                    React.createElement("br", null),
                    "\u3067\u304D\u308B\uFF01"))),
        React.createElement("div", { className: "DesktopStartPage-startButtonContainer" }, isPassportLinksShown ? (React.createElement(PassportLinks, null)) : (React.createElement(LinkButton, { to: HOME_PAGE, onClick: handleClickStart },
            React.createElement(Button, { type: "button", className: "DesktopStartPage-startButton", variant: "primary", size: "md", full: true }, "\u540C\u610F\u3057\u3066\u59CB\u3081\u308B")))),
        React.createElement("div", { className: "DesktopStartPage-border" }),
        React.createElement("div", { className: "DesktopStartPage-links" },
            React.createElement(LegalDisclaimer, { className: "DesktopStartPage-legal" }))));
};
export default DesktopStartPage;
